import { useEffect, useState } from 'react'

type UseAvoidLayoutShiftResponse = {
  isSkeletonVisible: boolean
}

type UseAvoidLayoutShiftParams = {
  duration?: number
  callbackBeforeRender?: () => void
}

const useAvoidLayoutShift = ({
  duration = 500,
  callbackBeforeRender,
}: UseAvoidLayoutShiftParams = {}): UseAvoidLayoutShiftResponse => {
  const [isSkeletonVisible, setIsSkeletonVisible] = useState(true)

  useEffect(() => {
    // avoid layout shift
    setTimeout(() => {
      callbackBeforeRender?.()
      setIsSkeletonVisible(false)
    }, duration)
  }, [])

  return { isSkeletonVisible }
}

export default useAvoidLayoutShift
